import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { Breed } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled?: boolean;
}

function FieldBreeds(props: Props): ReactElement {
  const { disabled } = props;
  const breeds: Breed[] = pricingContent?.breeds || [];
  breeds.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Form.Item
      label="Breed"
      name="breedId"
      labelCol={{ span: 15 }}
      wrapperCol={{ span: 15 }}
      rules={[{ required: true, message: 'This field is required' }]}
    >
      <Select
        data-testid={testId.fieldBreeds}
        placeholder="Select"
        disabled={disabled}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {breeds.map((breed: Breed) => (
          <Select.Option
            data-testid={testId.fieldBreedOption}
            key={breed.id}
            value={breed.id}
          >
            {breed.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default FieldBreeds;
